import { css } from '@mui/material'

import { unit } from '../utils'

export const serratedEdgeVerticalCss = (size?: number) => css`
  // https://css-generators.com/custom-borders/
  mask: conic-gradient(from -135deg at right, #0000, #000 1deg 89deg, #0000 90deg) 50% / 100% ${unit(size || 3)};
`
